export const dynamicImageWithPublicUrl = (data) => {
  return data?.image?.image?.localFile?.publicURL
}

export const dynamicImageWithGatsbyImage = (data) => {
  return data?.image?.image?.localFile?.childImageSharp?.gatsbyImageData
}
